import { memo, ReactNode } from "react";
import { createMimicMessageContext, ExpectedMessageProps, MimicMessageProviderProps } from "@tecorien/mimic-v2";
import { AresModalProps } from "../styled/AresModal";
import { ModalContainer } from "./ModalContainer";

export type WrappedModalProps = ExpectedMessageProps & Omit<AresModalProps, "isOpen" | "onRequestClose" | "overlayElement">;

const { useControls, useMessages, MessageProvider } = createMimicMessageContext<WrappedModalProps>();

export const useModal = () => useControls();
export const useModalMessages = () => useMessages();

export type ModalProviderProps = MimicMessageProviderProps<WrappedModalProps> & { children: ReactNode | ReactNode[] };
export const ModalProvider = memo<ModalProviderProps>((
  {
    children,
    ...props
  },
) => {
  return (
    <MessageProvider {...props}>
      {children}
      <ModalContainer />
    </MessageProvider>
  );
});